import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../contexts/AppProvider";

const Dashboard: React.FC = () => {
    const { authToken } = useAppContext();
    const navigate = useNavigate();

    useEffect(() => {
        if (!authToken) {
            navigate("/troypus");
            return;
        }
    }, [authToken, navigate]);

    return (
        <div className="starry-bg min-h-screen flex flex-col items-center justify-center text-white bg-black px-4">
            <div className="text-center mb-10">
                <h1 className="text-3xl font-bold mb-2">DASHBOARD</h1>
                <p className="text-gray-400 text-sm">Manage Content</p>
            </div>

            <div className="w-full max-w-3xl grid grid-cols-1 sm:grid-cols-3 gap-6">
                <button
                    onClick={() => navigate("/skill")}
                    className="p-6 rounded-xl bg-gray-800 hover:bg-gray-700 border border-gray-600 text-center transition duration-200"
                >
                    <div className="text-2xl font-semibold mb-2">SKILL</div>
                    <p className="text-gray-400 text-sm">CRUD</p>
                </button>
                <button
                    onClick={() => navigate("/project")}
                    className="p-6 rounded-xl bg-gray-800 hover:bg-gray-700 border border-gray-600 text-center transition duration-200"
                >
                    <div className="text-2xl font-semibold mb-2">PROJECT</div>
                    <p className="text-gray-400 text-sm">CRUD</p>
                </button>
                <button
                    onClick={() => navigate("/articles")}
                    className="p-6 rounded-xl bg-gray-800 hover:bg-gray-700 border border-gray-600 text-center transition duration-200"
                >
                    <div className="text-2xl font-semibold mb-2">BLOG</div>
                    <p className="text-gray-400 text-sm">CRUD</p>
                </button>
            </div>
        </div>
    );
};

export default Dashboard;